import {Component, computed, inject, OnInit} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AvailableArrayOperators} from '@em/data-feed/util-types';
import {ProductsGateway} from '@em/shared/api-interface';
import {EmSelectOperandModule} from '@em/shared/mapping-engine/feature';
import {EmSelectModule} from '@em/shared/ui';
import {ScopedCountryService} from '@em/user-account/data-access';
import {TranslateModule} from '@ngx-translate/core';
import {catchError, combineLatest, filter, map, of, take} from 'rxjs';
import {EmProductGroupConditionComponent} from '../product-group-condition/product-group-condition.component';

@Component({
  selector: 'em-custom-labels-condition',
  templateUrl: './custom-labels-condition.component.html',
  styleUrls: ['./custom-labels-condition.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmSelectModule,
    EmSelectOperandModule,
  ],
})
export class EmCustomLabelsConditionComponent
  extends EmProductGroupConditionComponent
  implements OnInit
{
  private readonly _productsGateway = inject(ProductsGateway);
  private readonly _scopedCountry = inject(ScopedCountryService);

  countryCode$ = toObservable(this._scopedCountry.getCountryCode());
  availableCustomLabels = toSignal(
    combineLatest([
      this.countryCode$.pipe(filter((country) => !!country)),
      this._productsGateway.getCustomLabels().pipe(),
    ]).pipe(
      take(1),
      map(
        ([country, customLabelsResp]) =>
          (customLabelsResp.custom_labels[country] as string[]) || [],
      ),

      catchError(() => of([])),
    ),
  );
  override selectedOperator = computed(() =>
    this.availableOperators()?.find(
      (op) => op.name === this.selectedOperatorName(),
    ),
  );

  override availableOperators = computed(() => AvailableArrayOperators);

  //#endregion
  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
